import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { KonfigurationenService } from 'lion-api';
import { KonfigurationenUtilService, UserStore } from '@shared/data';
import { firstValueFrom } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, take } from 'rxjs/operators';
import { Roles } from '@shared/util-auth';

export const appRoutingGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const konfigurationenService = inject(KonfigurationenService);
  const konfigurationenUtilService = inject(KonfigurationenUtilService);
  const userStore = inject(UserStore);

  // Wait until the user store is loaded
  await firstValueFrom(
    toObservable(userStore.loaded).pipe(
      filter((loaded) => loaded === true),
      take(1)
    )
  );

  const requestedRoute = window.sessionStorage.getItem('requested_route');
  window.sessionStorage.removeItem('requested_route');

  if (requestedRoute && requestedRoute !== '/' && requestedRoute !== '') {
    try {
      await router.navigateByUrl(requestedRoute);
      return false;
    } catch (error) {
      console.error('Failed to navigate to requested route, redirecting to default.', error);
    }
  }

  // Only perform the dynamic redirection for non-DZ Bank users
  const roles = userStore.roles();
  const isVrButNotReadOnly = roles.some((role) => role === Roles.LIO_VR_TRADER_1);
  const isFkButNotReadonly = userStore.isCorporateMode() && userStore.isFkTrader() && !userStore.isDzBankUser();
  if (isVrButNotReadOnly || isFkButNotReadonly) {
    try {
      const konfigKey = isFkButNotReadonly ? 'LIO_START_EXT_FK' : 'LIO_START_EXT';
      const response = await firstValueFrom(konfigurationenService.konfigurationenGet([konfigKey]));
      const startPage = konfigurationenUtilService.getKonfigurationValue(konfigKey, response.konfigurationen ?? []) || 'information';

      router.navigate([`/${startPage}`]);
      return false;
    } catch (error) {
      console.error('Failed to load start page configuration, redirecting to default.', error);
      router.navigate(['/information']);
      return false;
    }
  }

  // Default fallback for DZ Bank users or if anything else fails
  router.navigate(['/information']);
  return false;
};
